import { createFileRoute } from "@tanstack/react-router";
import { api } from "@/convex/_generated/api";
import { useQuery } from "convex/react";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Users } from "lucide-react";
import { Id } from "@/convex/_generated/dataModel";
import CompanyUsersTable from "@/components/users/company-users-table";

export const Route = createFileRoute(
  "/_super/super/control-panel/$companyId/users",
)({
  component: CompanyUsersManagement,
  validateSearch: (search: Record<string, unknown>) => ({
    page: search.page ? Number(search.page) : 1,
    search: search.search ? String(search.search) : undefined,
    state: search.state ? String(search.state) : undefined,
    roleType: search.roleType ? String(search.roleType) : undefined,
  }),
});

function CompanyUsersManagement() {
  const { companyId } = Route.useParams();
  const searchParams = Route.useSearch();

  const details = useQuery(
    api.companies.subscriptions.queries.getCompanySubscriptionDetails,
    {
      companyId: companyId as Id<"companies">,
    },
  );

  if (!details) {
    return (
      <div className="space-y-6">
        <Card className="animate-pulse">
          <CardHeader>
            <div className="h-4 bg-muted rounded w-1/2" />
          </CardHeader>
          <CardContent>
            <div className="space-y-2">
              <div className="h-3 bg-muted rounded" />
              <div className="h-3 bg-muted rounded w-5/6" />
            </div>
          </CardContent>
        </Card>
      </div>
    );
  }
  return (
    <div className="space-y-6">
      <CompanyUsersTable
        currentPage={searchParams.page || 1}
        basePath={`/super/control-panel/${companyId}/users`}
        searchParams={{
          ...searchParams,
        }}
        companyId={companyId as Id<"companies">}
      />
    </div>
  );
}
